export interface AppConfig {
  apiVersion?: string;
  apiHeader?: string;
}

const getAppConfig = (): AppConfig => {
  const apiVersion = import.meta.env.VITE_APP_API_VERSION;
  const apiHeader = import.meta.env.VITE_APP_API_VERSION_HEADER;
  return {
    apiVersion,
    apiHeader,
  };
};

export const appConfig = getAppConfig();
